import '../styles/main.scss';

import './jquery-global';
import 'jquery-migrate';
import 'bootstrap';
import 'lightbox2/dist/js/lightbox.js';
import fitvids from 'fitvids';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

const $ = window.jQuery;

const initSwipers = () => {
  const sliderEl = document.querySelector('.slider.swiper');
  if (sliderEl) {
    new Swiper(sliderEl, {
      modules: [Autoplay, Pagination],
      direction: 'vertical',
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: sliderEl.querySelector('.swiper-pagination'),
        clickable: true,
      },
      slidesPerView: 1,
      allowTouchMove: true,
    });
  }

  const sponsorEl = document.querySelector('.sponsor.swiper');
  if (sponsorEl) {
    new Swiper(sponsorEl, {
      modules: [Autoplay],
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }
};

const initThemeScripts = () => {
  if (!$) {
    return;
  }

  fitvids();
  initSwipers();

  $('.hamburger-toggle').on('click', function () {
    $(this).find('i').toggleClass('bi-list bi-x');
  });

  $('[data-tooltip="true"]').tooltip();

  const scrollTopButton = document.getElementById('scroll-top');
  if (scrollTopButton) {
    const toggleScrollTop = () => {
      const shouldShow =
        document.body.scrollTop > 20 || document.documentElement.scrollTop > 20;
      scrollTopButton.style.display = shouldShow ? 'block' : 'none';
    };

    window.addEventListener('scroll', toggleScrollTop, { passive: true });
    toggleScrollTop();
  }
};

$(initThemeScripts);
